export default __webpack_public_path__ + "static/media/how-4@2x.48f96582.png";